import React from 'react'
import styled from 'styled-components'
import {
  Slider as CompoundSlider,
  Handles,
  Tracks,
  Rail,
  Ticks
} from 'react-compound-slider'

import { FormLabel } from 'components/base/FormLabel'
import { getWeek } from 'components/main/main.component'
const isMobile = window.innerWidth < 712
const Handle = styled.div`
  font-family: var(--font-plex);
  position: absolute;
  top: 98px;
  transform: translateX(-50%);
  white-space: nowrap;

  &:hover {
    cursor: pointer;
    &::after {
    }
  }
  &::after {
    content: '';
    display: inline-block;
    background-color: var(--brandblue-main);
    width: 20px;
    height: 22px;
    position: absolute;
    left: -8px;
    top: 0px;
    border-radius: 3px;
    border: 1px solid var(--brandblue-main);
    -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  }
`
const ValueLabel = styled.div<{ positionPercent: number }>`
  font-weight: 400;
  font-size: 15px;
  position: absolute;
  padding: 0.75em 1em;
  line-height: 1em;
  bottom: 6px;
  text-align: center;
  transform: ${({ positionPercent }) =>
    positionPercent < 25
      ? 'translateX(-5%)'
      : positionPercent > 75
      ? 'translateX(-95%)'
      : 'translateX(-50%)'};
  background-color: var(--brandblue-bright-5);

  &:before {
    content: '';
    position: absolute;
    bottom: -11px;
    left: ${({ positionPercent }) =>
      positionPercent < 25 ? '5%' : positionPercent > 75 ? '95%' : '50%'};
    display: inline-block;
    width: 12px;
    height: 12px;
    transform: rotate(45deg) translateX(-50%);
    background-color: var(--brandblue-bright-5);
  }
`
const RailComponent = styled.div`
  position: absolute;

  width: 100%;
  display: inline-block;
  transform: translateY(-100px);
  max-height: 110px;
  &:hover {
    cursor: pointer;
  }
`
const Track = styled.div`
  background-color: var(--brandblue-bright-5);
  width: calc(100% + 16px);
  height: 18px;
  display: inline-block;
  position: absolute;
  top: 100px;
  margin-left: -8px;
  z-index: -1;
`
const SliderWrapper = styled.div`
  display: inline-block;
  position: relative;
  /* margin-top: 8px; */
  margin-bottom: 40px;
  margin-left: ${isMobile ? '16px' : '8px'};
  margin-right: ${isMobile ? '16px' : '8px'};
  width: ${isMobile ? 'calc(100% - 44px)' : 'calc(100% - 22px)'};

  label {
    margin-left: -8px !important;
  }
  .Slider {
    display: inline-block;
    width: 100%;
  }
`

const Tick = styled.div`
  font-family: var(--font-plex);
  font-size: 12px;
  position: absolute;
  top: 44px;
  line-height: 1em;
  padding-top: 4px;
  border-left: 1px solid var(--brandblue-bright-4);
  padding-left: 0.25em;
  color: var(--brandblue-bright-3);
`

const ThisWeekButton = styled.button`
  border: 0;
  padding: 0;
  background-color: transparent;
  border-bottom: 0.5px solid var(--brandblue-bright-2);
  color: var(--brandblue-bright-2);
  &:hover {
    color: var(--brandblue-main);
    border-bottom: 0.5px solid var(--brandblue-main);
    cursor: pointer;
  }
`

export const Slider: React.FC<{
  setValue: (value: any) => void
  currentValue: number
  range: number[]
  labels: string[]
  valueLabel?: (e: number) => React.ReactChild
  hideLabel?: boolean
  hideValueLabel?: boolean
  lang: 'de' | 'fr'
}> = ({
  setValue,
  currentValue = 0,
  range = [0, 100],
  labels = 'Sliderlabel',
  valueLabel = (e: number) => e,
  hideLabel = false,
  hideValueLabel = false,
  lang = 'de'
}) => {
  if (!currentValue) return null
  return (
    <SliderWrapper className='Slider'>
      {!hideLabel && (
        <FormLabel>
          {labels[0]}
          {getWeek(new Date()) !== currentValue && (
            <>
              {' '}
              |{' '}
              <ThisWeekButton
                onClick={() => {
                  setValue({
                    filterid: 'selectedWeek',
                    propid: getWeek(new Date())
                  })
                }}
              >
                {labels[1]}
              </ThisWeekButton>
            </>
          )}
        </FormLabel>
      )}
      <CompoundSlider
        step={1}
        onChange={e => {
          setValue({
            filterid: 'selectedWeek',
            propid: e[0]
          })
        }}
        domain={range}
        values={[currentValue]}
        className='Slider'
      >
        <Rail>
          {({ getRailProps }) => <RailComponent {...getRailProps()} />}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => {
            return (
              <div className='handles'>
                {handles.map((handle, i) => (
                  <Handle
                    key={'Key_Slider_Handle_' + i}
                    className='Handle'
                    {...getHandleProps(handle.id)}
                    style={{ left: handle.percent + '%' }}
                  >
                    {!hideValueLabel && (
                      <ValueLabel
                        className='valueLabel'
                        positionPercent={handle.percent}
                      >
                        {valueLabel(handle.value)}
                      </ValueLabel>
                    )}
                  </Handle>
                ))}
              </div>
            )
          }}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <Track {...getTrackProps()} className='Track'></Track>
          )}
        </Tracks>
        <Ticks count={12}>
          {({ ticks }) => (
            <div className='slider-ticks' style={{ position: 'relative' }}>
              {[...Array(12)].map((tick, i) => {
                const startDate = '2022-01-01'
                const diffInMs = +new Date(2022, i, 1) - +new Date(startDate)
                const diffInDays = diffInMs / (1000 * 60 * 60 * 24)
                let weeksinmonth = +(diffInDays / 7).toFixed(0)
                let show = new Date(2022, i, 1).toLocaleString(lang + '-CH', {
                  month: 'short'
                })
                return (
                  <Tick
                    key={'tick' + i}
                    style={{ left: (weeksinmonth * 100) / range[1] + '%' }}
                  >
                    {isMobile ? show[0] : show}
                  </Tick>
                )
              })}
            </div>
          )}
        </Ticks>
      </CompoundSlider>
    </SliderWrapper>
  )
}
